export const allColors = {
  primaryColor: '#0068EF',
  linearColorsName: ['#0BBCED', '#1252A5'],
}
